import { Button } from "@/components/ui/button";

interface AppointmentRequestActionsProps {
  onCancel: () => void;
  isLoading: boolean;
}

export const AppointmentRequestActions = ({
  onCancel,
  isLoading,
}: AppointmentRequestActionsProps) => {
  return (
    <div className="flex flex-col sm:flex-row justify-end gap-2">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
        className="w-full sm:w-auto order-2 sm:order-1"
      >
        Annuler
      </Button>
      <Button 
        type="submit" 
        disabled={isLoading}
        className="w-full sm:w-auto order-1 sm:order-2"
      >
        {isLoading ? "Envoi..." : "Envoyer la demande"}
      </Button>
    </div>
  );
};